import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        box: {
            backgroundColor: 'background.brand',
        },
        boximage: {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: {
                base: '100%',
                md: remCalc(229),
                lg: remCalc(226),
                xl: remCalc(213),
            },
        },
        textblock: {
            position: 'relative',
            textAlign: {base: 'center', md: 'left'},
        },
        cta: {
            textDecoration: 'none !important',
        },
    },
}
